import type { StaticTextResource } from '../keys'

export const km: StaticTextResource = {
  'schedule.dueToday': 'ថ្ងៃនេះ ដល់ម៉ោង {{time}}',
  'schedule.dueTomorrow': 'ថ្ងៃស្អែក ដល់ម៉ោង {{time}}',
  'schedule.durationRange':
    '{{start}} - {{end}} (ថ្ងៃទី {{currentDay}}/{{days}} ថ្ងៃ)',
  'editReport.defaultPageName': 'ទំព័រ {{n}}',
  'editReport.defaultSectionName': 'ផ្នែក',
  'editReport.defaultRepeatSectionName': 'ផ្នែកធ្វើដដែល',
}
